'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { type PrimedSupporterData, type SupporterQuery, primeSupporterData } from '../queries.ts';
import { useReadyForQueries, useSupporterQuery } from './base.ts';
type SeedableSupporterBundleData = Partial<PrimedSupporterData>;
export const usePrimeSupporterQuery = supporterQuery => {
  const $ = _c(10);
  const queryClient = useQueryClient();
  const {
    globalId
  } = useReadyForQueries();
  const [isSupporterQueryCachePrimed, setIsSupporterQueryCachePrimed] = useState(false);
  const queryResult = useSupporterQuery(supporterQuery);
  const {
    data,
    isLoading,
    isFetching,
    isPending,
    isError
  } = queryResult;
  let t0;
  let t1;
  if ($[0] !== data || $[1] !== globalId || $[2] !== queryClient) {
    t0 = () => {
      if (!data) {
        setIsSupporterQueryCachePrimed(false);
        return;
      }
      primeSupporterData(queryClient, data, globalId);
      setIsSupporterQueryCachePrimed(true);
    };
    t1 = [data, queryClient, globalId];
    $[0] = data;
    $[1] = globalId;
    $[2] = queryClient;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  const isShowingSkeletons = (isLoading || isFetching || isPending) && !data && !isError;
  const t2 = !isShowingSkeletons && isSupporterQueryCachePrimed;
  let t3;
  if ($[5] !== isShowingSkeletons || $[6] !== isSupporterQueryCachePrimed || $[7] !== queryResult || $[8] !== t2) {
    t3 = {
      ...queryResult,
      isShowingSkeletons,
      isSupporterQueryCachePrimed,
      isReadyToRenderChildren: t2
    };
    $[5] = isShowingSkeletons;
    $[6] = isSupporterQueryCachePrimed;
    $[7] = queryResult;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};